import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);
const KEY = "vanrock_quote_cart";

export const QuoteCartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [stage, setStage] = useState("cart");
  const [pending, setPending] = useState(null);

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch {}
  }, [items]);

  useEffect(() => {
    const legacy = (JSON.parse(localStorage.getItem(KEY) || "[]") || []).filter((i) => !i.rawName && i.slug);
    if (!legacy.length) return;
    Promise.all(
      legacy.map((i) =>
        api
          .get(`/parts/${i.slug}`)
          .then((r) => ({
            slug: i.slug,
            rawName: r.data.part.name,
            machType: r.data.part.machinery_type,
            brand: r.data.part.brand_name,
            model: r.data.part.model_name,
            code: r.data.part.part_code || "",
          }))
          .catch(() => null)
      )
    ).then((ups) => {
      const map = Object.fromEntries(ups.filter(Boolean).map((u) => [u.slug, u]));
      if (Object.keys(map).length)
        setItems((l) => l.map((i) => (map[i.slug] ? { ...i, ...map[i.slug] } : i)));
    });
  }, []);

  const openAdd = (part) => {
    setPending(part);
    setStage("add");
    setOpen(true);
  };
  const openCart = () => {
    setStage("cart");
    setOpen(true);
  };
  const close = () => setOpen(false);
  const addItem = (item) => {
    setItems((l) => [...l.filter((i) => i.slug !== item.slug), item]);
    setPending(null);
    setStage("cart");
  };
  const updateQty = (slug, qty) =>
    setItems((l) => l.map((i) => (i.slug === slug ? { ...i, qty } : i)));
  const removeItem = (slug) => setItems((l) => l.filter((i) => i.slug !== slug));
  const clear = () => setItems([]);

  return (
    <Ctx.Provider
      value={{ items, open, stage, setStage, pending, openAdd, openCart, close, addItem, updateQty, removeItem, clear }}
    >
      {children}
    </Ctx.Provider>
  );
};

export const useQuoteCart = () => useContext(Ctx);
